import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Transition, Listbox } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/solid'
import clsx from 'clsx'

const DropDown = ({
    data,
    keyToShow,
    keyToFind,
    selected,
    setSelectedValue: setSelected,
    name,
    placeholder,
    label,
    required,
    customRender,
    disabled,
    error,
    variant,
    className,
    isSmall,
    hasError = true,
}) => {
    const [query, setQuery] = useState('')
    const isBlack = variant === 'black' ? true : false

    const filteredPeople =
        query === ''
            ? data
            : data?.length > 0 &&
              data.filter(
                  item =>
                      item[keyToFind] &&
                      item[keyToFind]
                          ?.toLowerCase()
                          ?.replace(/\s+/g, '')
                          ?.includes(query.toLowerCase().replace(/\s+/g, '')),
              )

    return (
        <div className={clsx('relative flex flex-col items-start', className)}>
            {label && (
                <label
                    htmlFor="example"
                    className={clsx(
                        'text-sm font-medium mb-2',
                        isBlack ? 'text-white' : 'text-textDarkerGray',
                    )}
                >
                    {label}
                    {required && (
                        <span className="text-sm font-semibold text-error">
                            {' '}
                            *
                        </span>
                    )}
                </label>
            )}
            <Listbox name={name} value={selected} onChange={setSelected}>
                <div
                    className={clsx(
                        'relative w-full max-w-full',
                        isSmall ? 'h-12' : 'h-auto',
                    )}
                >
                    <div
                        className={clsx(
                            'relative flex flex-row items-center justify-between w-full px-4 py-3 cursor-default overflow-hidden  text-left outline-none border sm:text-sm',
                            isBlack
                                ? 'bg-black70 border-black60'
                                : 'bg-white border-grayLines',
                            isSmall ? 'h-12 rounded-xl' : 'rounded-xl',
                        )}
                    >
                        <Listbox.Button className="w-full flex-row flex-grow p-0 h-9 justify-between">
                            <div className="w-full flex-grow overflow-hidden truncate h-9 flex items-center justify-start max-w-85">
                                {selected && customRender ? (
                                    <>{customRender(selected)}</>
                                ) : (
                                    <div
                                        id={name}
                                        className={clsx(
                                            'text-sm outline-none font-normal',
                                            isBlack
                                                ? 'placeholder-black30 text-white bg-black70'
                                                : 'text-textDarkerGray bg-white',
                                        )}
                                    >
                                        {data?.length > 0 && selected ? (
                                            selected?.[keyToShow]
                                        ) : (
                                            <input
                                                className={clsx(
                                                    isBlack && 'bg-black70',
                                                )}
                                                placeholder={placeholder}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="absolute inset-y-0 right-0 flex items-center max-w-15">
                                <ChevronDownIcon
                                    className={clsx(
                                        'h-5 min-w-5 w-5 min-h-5',
                                        isBlack
                                            ? 'text-black30'
                                            : 'text-black70',
                                    )}
                                    aria-hidden="true"
                                />
                            </div>
                        </Listbox.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        afterLeave={() => setQuery('')}
                    >
                        <Listbox.Options
                            className={clsx(
                                'absolute mt-1 max-h-80 w-full overflow-auto rounded-md text-base focus:outline-none sm:text-sm shadow-md z-100',
                                isBlack ? 'bg-black70' : 'bg-white',
                                disabled && 'hidden',
                            )}
                        >
                            {filteredPeople.length === 0 && query !== '' ? (
                                <div
                                    className={clsx(
                                        'relative cursor-default select-none py-2 px-4',
                                        isBlack ? 'text-white' : 'text-black70',
                                    )}
                                >
                                    Nothing found.
                                </div>
                            ) : (
                                filteredPeople.map((item, index) => (
                                    <Listbox.Option
                                        key={`option-${index}`}
                                        className={({ active }) =>
                                            `transition-all relative select-none py-2 pl-10 pr-4 cursor-pointer ${(isBlack &&
                                                active &&
                                                'text-white bg-black50',
                                            isBlack &&
                                                !active &&
                                                'text-white bg-transparent',
                                            !isBlack &&
                                                !active &&
                                                'text-textDarkGray bg-transparent',
                                            !isBlack &&
                                                active &&
                                                'text-textDarkerGray bg-grayBackground')}`
                                        }
                                        value={item}
                                    >
                                        {({
                                            selected: selectedAct,
                                            active,
                                        }) => (
                                            <>
                                                <span
                                                    className={clsx(
                                                        `block truncate`,
                                                        selectedAct
                                                            ? 'font-medium'
                                                            : 'font-normal',
                                                        active &&
                                                            !isBlack &&
                                                            'text-textDarkerGray',
                                                        active &&
                                                            isBlack &&
                                                            'text-white',
                                                        !active &&
                                                            isBlack &&
                                                            'text-white',
                                                        !active &&
                                                            !isBlack &&
                                                            'text-textDarkGray',
                                                    )}
                                                >
                                                    {item[keyToShow] || ''}
                                                </span>
                                                {selectedAct ? (
                                                    <span
                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${(active &&
                                                            !isBlack &&
                                                            'text-textDarkerGray',
                                                        active &&
                                                            isBlack &&
                                                            'text-white',
                                                        !active &&
                                                            isBlack &&
                                                            'text-white',
                                                        !active &&
                                                            !isBlack &&
                                                            'text-textDarkGray')}`}
                                                    >
                                                        <CheckIcon
                                                            className="h-5 w-5"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))
                            )}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
            {hasError === true && (
                <p
                    className={clsx(
                        error ? 'visible' : 'invisible',
                        'w-full h-4 text-right text-error font-medium text-xs mt-1',
                    )}
                >
                    {error}
                </p>
            )}
        </div>
    )
}

DropDown.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    keyId: PropTypes.string,
    keyToShow: PropTypes.string,
    keyToFind: PropTypes.string,
    selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.any,
    ]),
    setSelectedValue: PropTypes.func.isRequired,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    customRender: PropTypes.func,
    error: PropTypes.string,
    variant: PropTypes.string,
    className: PropTypes.string,
    isSmall: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
}

export default DropDown
